import axios from "axios";
import { services } from "configs/api";
import { toSnakeCaseKeys } from "common/helpers/utils";

const Ondemand = {
  list(product, params = {}) {
    return axios.get(services.productService(product, "ondemand", ""), {
      params,
    });
  },
  get(id, product) {
    return axios.get(services.productService(product, "ondemand", id));
  },
  create(payload) {
    return axios.post(
      services.productService(payload.product, "ondemand", ""),
      toSnakeCaseKeys(payload)
    );
  },
};

export default Ondemand;
